import { EarningsItemBase } from '@api';
import { formatInTimeZone } from 'date-fns-tz';

export const formatScheduledDate = (date: Date): string => {
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const formatted = formatInTimeZone(date, timeZone, "MMM d yyyy'·'h:mmaaa");

  const timeZoneName =
    new Intl.DateTimeFormat('en-US', {
      timeZone,
      timeZoneName: 'short',
    })
      .formatToParts(date)
      .find(part => part.type === 'timeZoneName')?.value ?? '';

  return `${formatted} ${timeZoneName}`;
};

export const parseEarningsData = (
  isPreview: boolean,
  earningsData?: EarningsItemBase
) => {
  const epsValue = isPreview
    ? earningsData?.eps?.estimate
    : earningsData?.eps?.value;
  const epsDelta = earningsData?.eps?.surprise_percentage;
  const currency = earningsData?.currency;
  const reportingDate = earningsData?.reporting_date;
  const isBeat = epsDelta !== undefined && epsDelta > 0;

  return {
    epsValue,
    epsDelta,
    currency,
    reportingDate,
    isBeat,
  };
};
